import styled from 'styled-components';
import { InputLabel, InputLabelProps } from '@mui/material';

export const SelectInputLabel = styled(InputLabel)<{
  $size?: 'small' | 'medium';
}>`
  background: ${({ disabled }) =>
    disabled ? 'transparent !important' : 'white'};

  &.MuiInputLabel-root {
    top: ${({ $size }) => ($size === 'medium' ? '-6px' : '-11px')};
  }
  &.MuiInputLabel-shrink {
    font-size: ${({ $size }) => ($size === 'small' ? '14px' : undefined)};
    top: ${({ $size }) => ($size === 'small' ? '1px' : 0)};
    padding: 0 4px;
  }
`;

type Props = Omit<InputLabelProps, 'size'> & {
  size?: 'small' | 'medium';
};

const DropDownInputLabel = ({ size, ...props }: Props) => (
  <SelectInputLabel $size={size} {...props} />
);

DropDownInputLabel.defaultProps = {
  size: 'medium',
};

export default DropDownInputLabel;
